import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import { SubstanceDrugsClearanceModel } from './types';
import substanceDrugsClearanceItemValidator from './validators/item';

const substanceDrugsClearanceValidator: ValidateJSModel<SubstanceDrugsClearanceModel> = {
  UsedDrugs: { presence: true, hasValue: { validator: hasYesOrNo } },
  List: (value, attributes) => {
    if (attributes?.UsedDrugs && attributes?.UsedDrugs.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: substanceDrugsClearanceItemValidator },
      };
    }
    return {};
  },
  Comments: {},
  SummaryComments: {},
};

export default substanceDrugsClearanceValidator;
